import React from "react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Field } from "./Field";

export const PersonalFields = ({ form, update }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
    <Field label="Full name" required>
      <Input
        data-testid="form-full-name"
        value={form.full_name}
        onChange={(e) => update("full_name", e.target.value)}
        placeholder="Jane Doe"
        required
      />
    </Field>
    <Field label="Email" required>
      <Input
        data-testid="form-email"
        type="email"
        value={form.email}
        onChange={(e) => update("email", e.target.value)}
        placeholder="jane@example.com"
        required
      />
    </Field>
    <Field label="Phone or WhatsApp" required>
      <Input
        data-testid="form-phone"
        value={form.phone}
        onChange={(e) => update("phone", e.target.value)}
        placeholder="+1 (876) ..."
        required
      />
    </Field>
    <Field label="Senior's name (optional)">
      <Input
        data-testid="form-senior-name"
        value={form.senior_name}
        onChange={(e) => update("senior_name", e.target.value)}
      />
    </Field>
    <Field label="I am inquiring as" required>
      <Select value={form.relationship} onValueChange={(v) => update("relationship", v)}>
        <SelectTrigger data-testid="form-relationship"><SelectValue placeholder="Select one" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="self">Myself (Senior)</SelectItem>
          <SelectItem value="adult_child">Adult child / family</SelectItem>
          <SelectItem value="family">Extended family</SelectItem>
          <SelectItem value="other">Other</SelectItem>
        </SelectContent>
      </Select>
    </Field>
    <Field label="Service of interest" required>
      <Select value={form.service_interest} onValueChange={(v) => update("service_interest", v)}>
        <SelectTrigger data-testid="form-service"><SelectValue placeholder="Select one" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="consultation">Initial consultation</SelectItem>
          <SelectItem value="in_home_care">In-home care</SelectItem>
          <SelectItem value="essential">Essential relocation</SelectItem>
          <SelectItem value="premium">Premium relocation</SelectItem>
          <SelectItem value="elite">Elite relocation</SelectItem>
          <SelectItem value="property">Property management</SelectItem>
          <SelectItem value="other">Other</SelectItem>
        </SelectContent>
      </Select>
    </Field>
    <Field label="Current location" className="md:col-span-2">
      <Input
        data-testid="form-location"
        value={form.location}
        onChange={(e) => update("location", e.target.value)}
        placeholder="City, Country"
      />
    </Field>
  </div>
);
